import { render } from "./supplyFinancial.vue?vue&type=template&id=87e4e7a6&scoped=true"
import script from "./supplyFinancial.vue?vue&type=script&lang=js"
export * from "./supplyFinancial.vue?vue&type=script&lang=js"

import "./supplyFinancial.vue?vue&type=style&index=0&id=87e4e7a6&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e4e7a6"]])

export default __exports__